export default __webpack_public_path__ + "b9eaf31697b71e27e4af8fc1a51c1ca1.png";